import { redirect } from "react-router-dom";
import { WELCOME_PATH } from "../../../../constants/env";
import { abacGuardService } from "../services/abac.guard.service";
import type { AbacAction, AbacLoaderOptions, AbacModel } from "../types/abac.type";
import type { GuardLoaderFunction } from "../types/guard.type";

export function createAbacLoader(options: Readonly<AbacLoaderOptions>) {
  const { permission, redirectTo = WELCOME_PATH, requireAuth = true } = options;

  const abacLoader = async function abacLoader(): Promise<null | Response> {
    const result = abacGuardService.check(permission, { redirectTo, requireAuth });

    const isAllowed = result.allowed;
    if (!isAllowed && result.redirectTo) {
      return redirect(result.redirectTo);
    }

    return null;
  };

  return abacLoader;
}

export function abacLoader(can: AbacAction, model: AbacModel, redirectTo?: string): GuardLoaderFunction {
  const abacLoader = createAbacLoader({ permission: { can, model }, redirectTo });
  return abacLoader;
}
